import VueI18n from 'vue-i18n'
import { defaultLanguage, tenantI18nStrings } from '@/helpers/Tenant'
import Vue from 'vue'

// Vue must be configured to use the Vue18n component first.
// @see https://stackoverflow.com/a/64402138
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: defaultLanguage,
  messages: tenantI18nStrings(),
})
